import { render, staticRenderFns } from "./SinglePayments.vue?vue&type=template&id=b5c294ae&"
import script from "./SinglePayments.vue?vue&type=script&lang=js&"
export * from "./SinglePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePayments.vue"
export default component.exports